<template>
  <el-dialog title="登录" :visible.sync="show" width="400px" class="loginWrapper" @close="$emit('cancel')">
    <el-form :model="form" :rules="rules" ref="loginForm">
      <el-form-item label="登录账号" prop="username">
        <el-input v-model="form.username" maxlength="20" clearable placeholder="您的账号"></el-input>
      </el-form-item>
      <el-form-item label="登录密码" prop="password">
        <el-input v-model="form.password" maxlength="20" clearable show-password placeholder="您的登录密码"></el-input>
      </el-form-item>
      <el-button type="text" class="forgetPass" @click="forgetPassEvent">{{ forgetPassText }}</el-button>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" class="loginBtn" @click="submitForm('loginForm')">登录</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { opPostRequest } from '../utils/request'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'Login',
  props: {
    loginVisible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(['token'])
  },
  data () {
    return {
      show: false,
      form: {
        username: '',
        password: ''
      },
      forgetPassText: '忘记密码？',
      rules: {
        username: [
          { required: true, message: '请输入登录账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入登录密码', trigger: 'change' }
        ]
      }
    }
  },
  watch: {
    loginVisible: {
      handler (nval) {
        this.show = nval
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    ...mapActions(['SetToken']),
    async submitForm (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // this.$emit('confirm', this.form)
          const res = await opPostRequest('/api/operation-activity-center/out/v1/lingxun/login', { ...this.form })
          const { code, message, data } = res
          if (code === '0000' && data) {
            const { token, username } = data
            this.SetToken(token)
            localStorage.setItem('USERNAME', username)
            this.resetForm('loginForm')
            this.$emit('confirm')
          } else {
            this.$message({
              type: 'error',
              message
            })
          }
        } else {
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    forgetPassEvent () {
      this.forgetPassText = '请联系客服邮箱：jeffx@foxmail.com'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .loginWrapper{
    height: 100%;
    width: 100%;
    .el-form-item{
      margin-bottom: 12px;
    }
    .forgetPass{
      float: left;
      // margin-top: 10px;
    }
    .dialog-footer{
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      .loginBtn{
        width: 150px;
        background-color: #BC1A33;
        border-color: #BC1A33;
        color: #fff;
        font-size: 16px;
        font-weight: 500;
      }
    }
  }
</style>
